import { render } from "./ContactPopupTrigger.vue?vue&type=template&id=2355cf2a"
import script from "./ContactPopupTrigger.vue?vue&type=script&lang=js"
export * from "./ContactPopupTrigger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__